import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import ServicesBento from "../components/sections/ServicesBento";
import About from "../components/sections/About";
import Projects from "../components/sections/Projects";
import AICapabilities from "../components/sections/AICapabilities";
import Foundations from "../components/sections/Foundations";
import TechMarquee from "../components/sections/TechMarquee";
import TrackRecord from "../components/sections/TrackRecord";
import CTA from "../components/sections/CTA";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          if (window.__lenis) {
            window.__lenis.scrollTo(el, { offset: -80 });
          } else {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 300);
      }
    } else if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <ServicesBento />
      <About />
      <Projects />
      <AICapabilities />
      <Foundations />
      <TechMarquee />
      <TrackRecord />
      <CTA />
    </main>
  );
}
